import React from "react";
import NAEventOverview from "./NAEventOverview";
import NAWhyItMattersSection from "./NAWhyItMattersSection";
import NAFocusAreasSection from "./NAFocusAreasSection";
import NAChicagoSection from "./NAChicagoSection";
import NAStatisticsSection from "./NAStatisticsSection";
import NAWhoWhyAttendSection from "./NAWhoWhyAttendSection";
import NAClosingVisionSection from "./NAClosingVisionSection";
import { darkSectionBg } from "../darkSectionTokens";

function NAConferenceSections() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;
  const bg = require("assets/images/bg.png");

  return (
    <div
      id="about"
      className="section section-with-space pt-0 pb-0"
      style={darkSectionBg(bg, size)}
      data-parallax={true}
    >
      <NAEventOverview />
      <NAWhyItMattersSection />
      <NAFocusAreasSection />
      <NAChicagoSection />
      <NAStatisticsSection />
      <NAWhoWhyAttendSection />
      <NAClosingVisionSection />
    </div>
  );
}

export default NAConferenceSections;
